angular.module('picmonicng').filter('filterOr', [
  '$filter',
  function ($filter) {
    return function (input, filters) {
      var output = [];

      for (var a in filters) {
        var matches = $filter('filter')(input, filters[a]);

        for (var b in matches) {
          if (output.indexOf(matches[b]) < 0) {
            output.push(matches[b]);
          }
        }
      }

      return output;
    };
  },
]);
